export default "__VITE_ASSET__C0$LQb3E__"